export default function altTextCreator({startingText = '', secondaryText = '', productTitles = [], isConcatText = false}){
    let alt = startingText;
    const arrayLength = productTitles.length;

    if(arrayLength === 0 && startingText !== '') return `${alt}.`;

    else if(arrayLength > 0){
        alt = isConcatText ? `${alt}${secondaryText}` : secondaryText;

        alt += productTitles.reduce((previous, current, index) => {
            if(index > 0 && index + 1 !== arrayLength) previous = `${previous},`;
            else if(arrayLength > 1 && index + 1 === arrayLength) previous = `${previous} and`;

            current = ` [${current}]`;
            return `${previous}${current}`
        }, '' );
        return `${alt}.`;
    }
    return `${alt}`;
}
